import { Base2Presenter } from "core/presenter";
import { WebhookRepository } from "core/repository";

class WebhooksPresenter extends Base2Presenter {
  initialState() {
    return {
      webhooks: [],
      loading: true,
      editingWebhook: false,
      webhook: { endpoint: "", actions: [] },
      errors: {}
    };
  }

  onStart() {
    this.load();
  }

  async load() {
    this.enqueue({ loading: true });

    const companyUuid = this.routeParams.companyUuid;
    const currentUser = await this.mRuntime.get("currentUser");

    const result = await WebhookRepository.fetch({
      filters: [
        {
          connector: "AND",
          field: "company_uuid",
          operation: "EQ",
          value:
            companyUuid === "minha-empresa"
              ? currentUser.company_uuid
              : companyUuid
        },
        { connector: "AND", field: "deleted", operation: "EQ", value: "false" }
      ]
    });

    if (result.success) {
      this.enqueue({ webhooks: result.data });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não conseguimos buscar as webhooks para esta empresa! Tente novamente em alguns minutos."
      });
    }

    this.enqueue({ loading: false });
  }
}

export default WebhooksPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/webhooks/presenter.js